import Tooltip from "@material-ui/core/Tooltip";
import CancelIcon from "@mui/icons-material/Cancel";
import React, { Component } from "react";
import PtsConfirmDialogue from "../ptsAlert/PtsConfirmDialogue";

export class CancelButtons extends Component {
  confirmDialogueRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      onClick: props.onClick,
      pageId: this.props.pageId,
      hideToolTip: props.hideToolTip,
      btnName: props.btnName,
    };
  }

  // onClick() {
  //   if (this.state.onClick) {
  //     this.state.onClick();
  //   }
  // }

  deleteConfirmed() {
    if (this.confirmDialogueRef && this.confirmDialogueRef.current) {
      this.confirmDialogueRef.current.setState({ open: false });
    }
    if (this.state.onClick) {
      this.state.onClick();
    }
  }


  onClick() {
    if (
      this.confirmDialogueRef &&
      this.confirmDialogueRef.current &&
      this.confirmDialogueRef.current.state.open === false
    ) {
      this.confirmDialogueRef.current.handleClickOpen();
    } else {
      this.confirmDialogueRef.current.handleClose();
    }
  }

  render() {
    this.confirmDialogueRef = React.createRef();
    return (
      <span
        style={{
          cursor: "pointer",
          fontSize: "x-larger",
          alignItems: "center",
          marginRight: "6px",
        }}
      >
        <PtsConfirmDialogue
          ref={this.confirmDialogueRef}
          open={false}
          pageId={this.props.pageId}
          confirmCallback={this.deleteConfirmed.bind(this)}
        />
        {this.props.pageId === "scheduledCancelled" ?
          <Tooltip title="Cancel and delete" classes={{ popper: "custom-tooltip" }} arrow>
            <CancelIcon
              style={{
                color: "#b73d3d",
                cursor: "pointer",
                fontSize: "18px",
                width: "30px",
                minHeight: "30px",
                padding: "3px",
                alignContent: "center",
                textAlign: "center",
                fontWeight: "600",
              }}
              onClick={this.onClick.bind(this)}
            />
          </Tooltip> :
          <Tooltip title="Cancel" classes={{ popper: "custom-tooltip" }}>
            <CancelIcon
              style={{
                color: "#b73d3d",
                cursor: "pointer",
                fontSize: "18px",
                width: "30px",
                minHeight: "30px",
                padding: "3px",
                alignContent: "center",
                textAlign: "center",
                fontWeight: "600",
              }}
              onClick={this.onClick.bind(this)}
            />
          </Tooltip>}
      </span>
    );
  }
}
export default CancelButtons;
